import $ from 'jquery';
import Modal from '../Modal';
import { selectors } from '../Constants';

export default class StaticHeaderReduced {
  constructor(section) {
    this.section = section;
    this.modal = null;
    this.passwordTrigger = section.el.querySelector(selectors.password.trigger);

    if (this.passwordTrigger) {
      this._initPassword();
    }
  }

  onSectionUnload() {
    if (this.modal) {
      this.modal.unload();
    }

    if (this.passwordTrigger) {
      this.passwordTrigger.removeEventListener('click', this.onPasswordTrigger);
    }
  }

  _initPassword() {
    this.onModalClose = this._onModalClose.bind(this);
    this.onModalOpen = this._onModalOpen.bind(this);
    this.onPasswordTrigger = this._toggleModal.bind(this);
    this.passwordTrigger.addEventListener('click', this.onPasswordTrigger);

    this.modal = new Modal({
      onOpen: this.onModalOpen,
      onClose: this.onModalClose,
    });

    if (this.section.el.querySelector(selectors.password.errors)) {
      this._toggleModal();
    }
  }

  _toggleModal() {
    if (this.modal.isOpen()) {
      this.modal.close();
    } else {
      this.modal.open(selectors.password.modal, 'password');
    }
  }

  _onModalClose() {
    $(this.passwordTrigger).focus();
  }

  _onModalOpen($modal) {
    $modal.find('.form-element.input').focus();
  }
}
